"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactResizeDetector = _interopRequireDefault(require("react-resize-detector"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var useDimensions = function useDimensions(image, autoSizing) {
  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      result = _useState2[0],
      setResult = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    var _image$dimension;

    var _ref = (_image$dimension = image.dimension) !== null && _image$dimension !== void 0 ? _image$dimension : {},
        width = _ref.width,
        height = _ref.height;

    setResult(autoSizing === "auto" ? {
      width: width ? "".concat(width, "px") : undefined,
      height: height ? "".concat(height, "px") : undefined
    } : autoSizing === "cover-width" ? {
      width: "100%",
      height: "auto"
    } : autoSizing === "cover-height" ? {
      width: "auto",
      height: "100%"
    } : autoSizing === "fit" ? {
      width: "100%",
      height: "100%"
    } : {});
  }, [image, autoSizing]);
  return result;
};

var useOptimizedSrc = function useOptimizedSrc(image, imgRef, parentDimensions, quality) {
  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      src = _useState4[0],
      setSrc = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      parentWidth = _useState6[0],
      setParentWidth = _useState6[1];

  (0, _react.useLayoutEffect)(function () {
    if (imgRef.current) {
      var _imgRef$current;

      var newWidth = (_imgRef$current = imgRef.current) === null || _imgRef$current === void 0 ? void 0 : _imgRef$current.clientWidth; // Let the browser scale-down if we have loaded a bigger image.

      if (!parentWidth || newWidth && newWidth > parentWidth) {
        setParentWidth(newWidth);
      }

      var newSrc = "".concat(image.url, "?auto=webp").concat(parentWidth ? "&width=".concat(parentWidth) : "").concat(quality ? "&quality=".concat(quality) : "");
      setSrc(newSrc);
    }
  }, [image, parentDimensions, imgRef, parentWidth, quality]);
  return src;
};

var OptimizedContentStackImage = function OptimizedContentStackImage(imageProps) {
  return /*#__PURE__*/_react.default.createElement(_reactResizeDetector.default, {
    handleWidth: true,
    handleHeight: true,
    refreshMode: "debounce",
    refreshRate: 500,
    refreshOptions: {
      leading: true,
      trailing: true
    }
  }, function (dimensions) {
    return /*#__PURE__*/_react.default.createElement(AdaptiveContentStackImage, _extends({}, dimensions, imageProps));
  });
};

var Img = _styledComponents.default.img.withConfig({
  displayName: "OptimizedContentStackImage__Img",
  componentId: "sc-ds0l9k-0"
})(["width:", ";height:", ";max-width:100%;max-height:100%;"], function (_ref2) {
  var imgWidth = _ref2.imgWidth;
  return imgWidth;
}, function (_ref3) {
  var imgHeight = _ref3.imgHeight;
  return imgHeight;
});

var AdaptiveContentStackImage = function AdaptiveContentStackImage(_ref4) {
  var _image$dimension2, _image$dimension3;

  var width = _ref4.width,
      height = _ref4.height,
      image = _ref4.image,
      style = _ref4.style,
      autoSizing = _ref4.autoSizing,
      onLoad = _ref4.onLoad,
      quality = _ref4.quality;

  var _useDimensions = useDimensions(image, autoSizing),
      imgWidth = _useDimensions.width,
      imgHeight = _useDimensions.height;

  var imgRef = (0, _react.useRef)(null);
  var src = useOptimizedSrc(image, imgRef, {
    width: width,
    height: height
  }, quality);
  return /*#__PURE__*/_react.default.createElement(Img, {
    ref: imgRef,
    onLoad: onLoad // imgWidth and imgHeight are the actual calculated styles
    ,
    imgWidth: imgWidth,
    imgHeight: imgHeight // width & height are the intrinsic dimensions
    ,
    width: (_image$dimension2 = image.dimension) === null || _image$dimension2 === void 0 ? void 0 : _image$dimension2.width,
    height: (_image$dimension3 = image.dimension) === null || _image$dimension3 === void 0 ? void 0 : _image$dimension3.height,
    style: style,
    src: src,
    alt: image.title || " "
  });
};

var _default = OptimizedContentStackImage;
exports.default = _default;